import Vue from 'vue'
import Router from 'vue-router'
import H010010 from '@/pages/H010010'
import H020010 from '@/pages/H020010'
import H030010 from '@/pages/H030010'
import H040010 from '@/pages/H040010'
import H040020 from '@/pages/H040020'
import H040030 from '@/pages/H040030'
import H050010 from '@/pages/H050010'
import H050020 from '@/pages/H050020'
import H050030 from '@/pages/H050030'
import H050040 from '@/pages/H050040'
import H050050 from '@/pages/H050050'
import H060010 from '@/pages/H060010'
import H060020 from '@/pages/H060020'
import H070010 from '@/pages/H070010'
import H110010 from '@/pages/H110010'
import H110020 from '@/pages/H110020'
import H120010 from '@/pages/H120010'
import H200010 from '@/pages/H200010'
import H200020 from '@/pages/H200020'
import H200030 from '@/pages/H200030'
import H200040 from '@/pages/H200040'
import H200050 from '@/pages/H200050'
import H200060 from '@/pages/H200060'
import H300010 from '@/pages/H300010'
import H300020 from '@/pages/H300020'
import H300030 from '@/pages/H300030'
import H400010 from '@/pages/H400010'
import H400020 from '@/pages/H400020'
import H400030 from '@/pages/H400030'
import H400040 from '@/pages/H400040'
import H400060 from '@/pages/H400060'
import H400061 from '@/pages/H400061'
import H400062 from '@/pages/H400062'
import H400063 from '@/pages/H400063'
import H500010 from '@/pages/H500010'
import H500020 from '@/pages/H500020'
import E010010 from '@/pages/E010010'

import H600010 from '@/pages/H600010'
import H600020 from '@/pages/H600020'
import H000003 from '@/pages/H000003'

import H600030 from '@/pages/H600030'
import H600040 from '@/pages/H600040'
import H300000 from '@/pages/H300000'

import H700010 from '@/pages/H700010'
import H700020 from '@/pages/H700020'

import H800010 from '@/pages/H800010'
import H800020 from '@/pages/H800020'
import H800030 from '@/pages/H800030'
import H800040 from '@/pages/H800040'

Vue.use(Router)

export default new Router({
	routes: [{
			path: '/',
			name: 'H010010',
			component: H010010,
		},
		{
			path: '/H020010',
			name: 'H020010',
			component: H020010,
		},

		//开始
		//听评课
		{
			path: '/H600030',
			name: 'H600030',
			component: H600030,
		},
		{
			path: '/H600040',
			name: 'H600040',
			component: H600040,
		},
		{
			path: '/H300000/:id',
			name: 'H300000',
			component: H300000,
		},

		//回访
		{
			path: '/H600010',
			name: 'H600010',
			component: H600010,
		},
		{
			path: '/H600020',
			name: 'H600020',
			component: H600020,
		},
		{
			path: '/H000003/:id',
			name: 'H000003',
			component: H000003,
		},

		//结束



		{
			path: '/H030010',
			name: 'H030010',
			component: H030010,
		},
		{
			path: '/H040010',
			name: 'H040010',
			component: H040010,
		},
		{
			path: '/H040020',
			name: 'H040020',
			component: H040020,
		},
		{
			path: '/H040030',
			name: 'H040030',
			component: H040030,
		},
		{
			path: '/H050010',
			name: 'H050010',
			component: H050010,
		},
		{
			path: '/H050020',
			name: 'H050020',
			component: H050020,
		},
		{
			path: '/H050030',
			name: 'H050030',
			component: H050030,
		},
		{
			path: '/H050040',
			name: 'H050040',
			component: H050040,
		},
		{
			path: '/H050050',
			name: 'H050050',
			component: H050050,
		},
		{
			path: '/H060010',
			name: 'H060010',
			component: H060010,
		},
		{
			path: '/H060020',
			name: 'H060020',
			component: H060020,
		},
		{
			path: '/H070010',
			name: 'H070010',
			component: H070010,
		},
		{
			path: '/H110010',
			name: 'H110010',
			component: H110010,
		},
		{
			path: '/H110020',
			name: 'H110020',
			component: H110020,
		},
		{
			path: '/H120010',
			name: 'H120010',
			component: H120010,
		},
		{
			path: '/H200010',
			name: 'H200010',
			component: H200010,
		},
		{
			path: '/H200020',
			name: 'H200020',
			component: H200020,
		},
		{
			path: '/H200030',
			name: 'H200030',
			component: H200030,
		},
		{
			path: '/H200040',
			name: 'H200040',
			component: H200040,
		},
		{
			path: '/H200050',
			name: 'H200050',
			component: H200050,
		},
		{
			path: '/H200060',
			name: 'H200060',
			component: H200060,
		},
		{
			path: '/H300010',
			name: 'H300010',
			component: H300010,
		},
		{
			path: '/H300020',
			name: 'H300020',
			component: H300020,
		},
		{
			path: '/H300030',
			name: 'H300030',
			component: H300030,
		},
		{
			path: '/H400010',
			name: 'H400010',
			component: H400010,
		},
		{
			path: '/H400020',
			name: 'H400020',
			component: H400020,
		},
		{
			path: '/H400030',
			name: 'H400030',
			component: H400030,
		},
		{
			path: '/H400040',
			name: 'H400040',
			component: H400040,
		},
		{
			path: '/H400060',
			name: 'H400060',
			component: H400060,
		},
		{
			path: '/H400061/:id',
			name: 'H400061',
			component: H400061,
		},
		{
			path: '/H400062/:id',
			name: 'H400062',
			component: H400062,
		},
		{
			path: '/H400063',
			name: 'H400063',
			component: H400063,
		},
		{
			path: '/H500010',
			name: 'H500010',
			component: H500010,
		},
		{
			path: '/H500020',
			name: 'H500020',
			component: H500020,
		},
		{
			path: '/E010010',
			name: 'E010010',
			component: E010010,
		},
    {
      path: '/H700010',
      name: 'H700010',
      component: H700010,
    },
    {
      path: '/H700020',
      name: 'H700020',
      component: H700020,
    },
    {
      path: '/H800010',
      name: 'H800010',
      component: H800010,
    },
    {
      path: '/H800020',
      name: 'H800020',
      component: H800020,
    },
    {
      path: '/H800030',
      name: 'H800030',
      component: H800030,
    },
    {
      path: '/H800040',
      name: 'H800040',
      component: H800040,
    },
	]
})



// WEBPACK FOOTER //
// ./src/router/index.js